import { useIntParams } from "core/model/utils/urls";
import { ValueOf } from "core/types";
import { useCareproviderNavigationHandlers } from "dsl/hooks";
import { useEffect } from "react";
import { useAdmissionsContext } from "../AdmissionsContext";
import { AdmissionsFooter } from "../shared/AdmissionsFooter";
import { AdmissionsHeader } from "../shared/AdmissionsHeader";
import { FormSubmittedSuccess } from "./Screens/FormSubmittedSuccess";
import { LoginMailSuccess } from "./Screens/LoginMailSuccess";

export const ADMISSIONS_INFO_SCREENS = {
  FORM_SUBMITTED_SUCCESS: 2,
  LOGIN_EMAIL_SENT: 1,
} as const;

export type AdmissionsInfoScreen = ValueOf<typeof ADMISSIONS_INFO_SCREENS>;

const INFO_SCREEN_COMPONENTS: Record<
  AdmissionsInfoScreen,
  React.ComponentType
> = {
  [ADMISSIONS_INFO_SCREENS.FORM_SUBMITTED_SUCCESS]: FormSubmittedSuccess,
  [ADMISSIONS_INFO_SCREENS.LOGIN_EMAIL_SENT]: LoginMailSuccess,
};

export default function AdmissionsInfoScreens() {
  const { admissionsId, admissionsPayload } = useAdmissionsContext();
  const { infoType } = useIntParams<{ infoType: AdmissionsInfoScreen }>();
  const navigation = useCareproviderNavigationHandlers();
  const InfoScreenComponent = INFO_SCREEN_COMPONENTS?.[infoType] ?? null;

  useEffect(() => {
    if (!InfoScreenComponent) {
      setTimeout(() => {
        navigation.goToAdmissionsLogin({
          admissionsId,
        });
      }, 0);
    }
  }, [InfoScreenComponent, admissionsId, navigation]);

  if (!InfoScreenComponent) {
    return null;
  }

  return (
    <main className="flex min-h-screen flex-col">
      <AdmissionsHeader logo={admissionsPayload.logo} />
      <InfoScreenComponent />
      <AdmissionsFooter
        privacyURL={admissionsPayload.careprovider.profile?.privacy_url}
      />
    </main>
  );
}
